export const DIRECT_CONNECT_PROVIDER_NAME = 'Direct Connect'
export const UTILITY_CONNECTION_MODAL_QUERY_KEY = 'showUtilityConnectionModal'
